// Palette
import palette from '../palette';

export default {
  root: {
    height: '35px',
    '&$selected': {
      backgroundColor: palette.background.default
    },
    '&$hover': {
      '&:hover': {
        backgroundColor: palette.background.default
      }
    },
    padding: 0,
    lineHeight: 0,
    // fontSize: 16,
    // fontFamily: 'Roboto !important',
    // textAlign: 'end'
  }
};